
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"17","height":"17","fill":"#FFC439","rx":"1"}}),_c('path',{attrs:{"fill":"#001C64","d":"M7.313 4.47a.39.39 0 0 0-.382.327l-.636 4.03a.39.39 0 0 1 .383-.328h1.861a3.8 3.8 0 0 0 3.754-3.218 3 3 0 0 0 .037-.418 3.53 3.53 0 0 0-1.649-.393z"}}),_c('path',{attrs:{"fill":"#0070E0","d":"M12.33 4.863a3 3 0 0 1-.037.418A3.8 3.8 0 0 1 8.54 8.5H6.678a.39.39 0 0 0-.383.327l-.584 3.702-.366 2.323a.314.314 0 0 0 .31.363h2.021a.39.39 0 0 0 .383-.327l.532-3.375a.39.39 0 0 1 .383-.327h1.19a3.8 3.8 0 0 0 3.753-3.219c.206-1.314-.456-2.51-1.587-3.104"}}),_c('path',{attrs:{"fill":"#003087","d":"M5.017 1.785a.39.39 0 0 0-.382.326L3.05 12.166c-.03.19.117.363.31.363h2.352l.583-3.702.636-4.03a.39.39 0 0 1 .382-.326h3.368c.613 0 1.173.143 1.649.392.032-1.686-1.36-3.078-3.272-3.078z"}})])
          )
        }
      }
    